'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to print product details group (in a non-partner-specific, simple
 * way)
 */
    .directive('capProductDetailsGroup', function () {
        return {
            restrict: 'A',
            scope: {
                selection: "=",
                label: "="
            },
            templateUrl: "templates/productdetailsgroup.html"
        }
    });